import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { CustomCmsActions } from '@core/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DeviceService } from '@shared/services';
import { CmsActions, RouterState, RoutingService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, mergeMap, skip, switchMap, take } from 'rxjs/operators';

@Injectable()
export class CmsEffects {
  clearCms$: Observable<CustomCmsActions.CmsComponentsClearState> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(({ payload }) => payload),
      distinctUntilChanged(),
      skip(1),
      // После переключения города происходит загрузка pages, где прилетают новые данные
      // для загрузки компонентов, поэтому перед очисткой необходимо дождаться pages
      switchMap(() => this.actions$.pipe(ofType(CmsActions.LOAD_CMS_PAGE_DATA_SUCCESS), take(1))),
      map(() => new CustomCmsActions.CmsComponentsClearState()),
    ),
  );

  refreshPageWhenBreakpointChange$: Observable<CmsActions.LoadCmsPageData> = createEffect(() =>
    this.deviceService.deviceType$.pipe(
      skip(1),
      switchMap(() =>
        this.routingService.getRouterState().pipe(
          filter<RouterState>(
            (routerState) =>
              routerState && routerState.state && routerState.state.cmsRequired && !routerState.nextState,
          ),
          take(1),
          map((routerState) => routerState.state.context),
          mergeMap((context) => of(new CmsActions.LoadCmsPageData(context))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private routingService: RoutingService,
    private deviceService: DeviceService,
  ) {}
}
